import { makeUrl } from '@ms-cloudpack/path-string-parsing';
import type { LinkedPath, ResolveMapEntry } from '@ms-cloudpack/common-types';
import { findResolveMapEntry } from '@ms-cloudpack/package-utilities';

// Helper function to determine if we need to redirect to a remote host.
export function getLinkedPackageRedirectUrl(options: {
  linkedPaths: LinkedPath[];
  packageName: string;
  version: string;
  packageEntry: ResolveMapEntry;
  originalUrl: string;
}): string | undefined {
  const { linkedPaths, packageName, version, packageEntry, originalUrl } = options;

  // If there is any linked path with a remote we need to check if we should redirect to it.
  for (const { remote } of linkedPaths) {
    // Early exit if there is no remote.
    if (!remote) {
      continue;
    }
    // Remove the -linked suffix if it is linked to compare the version with the linked package map correctly.
    const realVersion = packageEntry.isLinked ? version.replace(/-linked$/, '') : version;
    const entry = findResolveMapEntry({ packageName, version: realVersion, resolveMap: remote.resolveMap });
    // Compare by path to see if we should redirect, since we could have multiple versions of the same package.
    if (entry?.path === packageEntry.path) {
      // Use the original URL to construct the new URL to keep query params.
      const nameIndexEnd = originalUrl.indexOf(packageName) + packageName.length + version.length + 1;
      // We want the request path to start with the package name and version to ignore any prefix.
      const linkedRequestPath = `./${packageName}@${realVersion}${originalUrl.substring(nameIndexEnd)}`;
      // Redirect URL using the remote host.
      return makeUrl(linkedRequestPath, `${remote.hostUrl}/`).href;
    }
  }

  return undefined;
}
